import { render } from "./Home.vue?vue&type=template&id=fcf7cff6&scoped=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=fcf7cff6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fcf7cff6"

export default script